<template>

    <form-dialog
        title="查看手术信息"
        :buttons="enabledEditButtons"
        :footerVisible="canEdit"
        :data="surgeryInfo"
        width="80%"
        :visible.sync="visibleSync"
        :columns="columnList"
        @confirm="putOne"
    ></form-dialog>
</template>
<script>
import definition from '../../common/Definition'
import { mapGetters } from 'vuex'
export default {
    name: `EditApplySurgery`,
    props: {
        visible: { type: Boolean },
        surgeryId: { type: Number },
        isReadOnly: { type: Boolean },
        editButtons: Array,
        footerVisible: {
            type: Boolean,
            default: true
        },
        readOnlyExcludeColumns: { type: Array }
    },
    data() {
        return {
            title: `编辑手术申请`,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            surgeryInfo: {},
            change_operating_room_id: -1, // 新手术间
            oldoperating_room_id: -1, // 初始手术间
            change_operating_ward_id: -1, // 新手术区
            oldoperating_ward_id: -1, // 初始手术区
            change_plan_time: null, // 新计划手术时间
            oldplan_time: null, // 初始计划手术时间
            requiredColumnList: [],
            checkCutLevel: this.$root.CheckCutLevel || `0`,
            scheduleWorkerFilter: this.$root.ScheduleWorkerFilter || `0`
        }
    },
    created() {
    },
    computed: {
        ...mapGetters([
            `surgery/visit_type`,
            `surgery/anaesthesia_method`,
            `operation_room_auth`,
            `section_auth`,
            `inpatient_section_auth`,
            `operation_ward_auth`,
            `sys_enums`,
            `sysuser/workers_by_duty`,
            `permissions`,
            `sysuser/workers_by_dutyNew`,
            `otherSettingColumn`,
            `extendColumnList`
        ]),
        worker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        columnList() {
            let me = this
            let detaileditWorker = this.permissions && this.permissions.findIndex(item => item.permission === `scheduling:detail_editWorker`) === -1
            let validateTime = (rule, value, callback) => {
                if (!value) {
                    return callback()
                }
                const selectedDate = new Date(value)
                const today = new Date()
                today.setHours(0, 0, 0, 0) // 重置今天的时间为00:00:00
                if (selectedDate > today) {
                    return callback(new Error(`选择的时间必须小于等于今天`))
                }
                callback()
            }

            let validatePhoneNumber = (rule, value, callback) => {
                if (!value) {
                    return callback()
                }
                const phoneReg = /^1[3-9]\d{9}$/ // 匹配中国大陆手机号
                if (!phoneReg.test(value)) {
                    return callback(new Error(`请输入有效的中国电话号码`))
                }
                callback()
            }

            let validateSocietyCard = (rule, value, callback) => {
                if (!value) {
                    return callback()
                }
                const societyCardReg = /^[0-9]{9,12}$/
                if (!societyCardReg.test(value)) {
                    return callback(new Error(`请输入正确的社保卡号`))
                }
                callback()
            }

            let createC = [
                {
                    type: `string`,
                    prop: `name`,
                    label: `姓名`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                    // validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `enum_sex`,
                    label: `性别`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    options: this.sys_enums.Enum_Sex || []
                },
                {
                    type: `datetime`,
                    prop: `plan_time`,
                    label: `手术时间`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    default: this.$moment().format(`YYYY/MM/DD 09:00:00`),
                    change: (that, { row }) => {
                        that.$parent.$parent.$parent.change_plan_time = row.plan_time
                    }
                    // validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `float`,
                    prop: `cost_time`,
                    label: `预计时长`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `his_id`,
                    label: `病案号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`apply_surgery.visit_no`),
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                    // validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `enum_surgery_type`,
                    label: `手术类型`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_SurgeryType || [],
                    colspan: 6,
                    default: 1
                },
                {
                    type: `select`,
                    prop: `enum_outoperatingroomtype`,
                    label: `室外麻醉分类`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_OutOperatingRoomType || [],
                    colspan: 6,
                    readonly: (that, { row }) => {
                        return this.surgeryInfo && this.surgeryInfo.enum_surgery_status > 20
                    }
                },
                {
                    type: `string`,
                    prop: `outpatient_no`,
                    label: `门诊号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `bed_no`,
                    label: `床号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `is_day_surgery`,
                    label: `日间手术`,
                    width: `80`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    options: `enum_bool`
                },
                {
                    type: `select`,
                    prop: `is_endoscopy`,
                    label: `内镜检查`,
                    width: `80`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    options: `enum_bool`
                },
                {
                    type: `select`,
                    prop: `card_type`,
                    label: `证件类型`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    options: this.sys_enums.Enum_CardType || []
                },
                {
                    type: `string`,
                    prop: `card_no`,
                    label: `证件号`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_diseases`,
                    label: `术前诊断`,
                    showCount: 3,
                    collapseTags: false,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    options: `/api/AcisSystem/Disease/Search`
                    // validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `enum_blood_type`,
                    label: `血型`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_BloodType || [],
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_rh_blood_type`,
                    label: `RH`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_RhBloodType || [],
                    colspan: 6
                },
                {
                    type: `remotemultiselect`,
                    prop: `plan_surgeries`,
                    label: `拟施手术`,
                    showCount: 3,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    colspan: 12,
                    options: `/api/AcisSystem/Surgery/Search`
                    // validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `height`,
                    label: `身高(cm)`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `weight`,
                    label: `体重(kg)`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_cut_level`,
                    label: `切口等级`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_CutLevel || [],
                    colspan: 6,
                    change: (that, { row }) => {
                        if (me.checkCutLevel && me.checkCutLevel == `1` && row.enum_cut_level == 1) {
                            me.$alert(`<strong>请确认是否I类手术切口</strong>`, `提示`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            })
                        }
                    }
                },
                {
                    type: `select`,
                    prop: `enum_surgery_scale`,
                    label: `手术分级`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_SurgeryScale || [],
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `nation`,
                    label: `民族`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `phone`,
                    label: `电话`,
                    isCreatable: true,
                    isEditable: true,
                    validate: [{ validator: validatePhoneNumber, trigger: `blur` }],
                    colspan: 6
                },
                {
                    // type: `select`,
                    type: `remoteselect`,
                    prop: `plan_surgeon`,
                    label: this.T(`apply_surgery.plan_surgeon`),
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    // options: this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || [],
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || []
                            let worksarr = _.cloneDeep(works)
                            if (me.scheduleWorkerFilter == `1`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_hospital_ward_id || _.includes(i.hospital_wardids, me.surgeryInfo.dic_hospital_ward_id)
                                })
                            } else if (me.scheduleWorkerFilter == `2`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_operating_ward_id || _.includes(i.wardids, me.surgeryInfo.dic_operating_ward_id)
                                })
                            }
                            if (this.$root.UseSurgeryScaleCheck == `1`) {
                                worksarr = worksarr.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        //  code: d.code,
                                        // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                        code: d.surgery_scale == null ? `--/${d.code}` : d.surgery_scale + `/` + d.code
                                    }
                                })
                            }

                            if (q && q.keyword) {
                                return worksarr.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return worksarr
                            }
                        }
                    }
                    // validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    // type: `multiselect`,
                    type: `remotemultiselect`,
                    prop: `plan_surgeon_assistants`,
                    label: this.T(`apply_surgery.plan_surgeon_assistants`),
                    isEditable: true,
                    isCreatable: true,
                    collapseTags: false,
                    // options: this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || [],
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`手术医生`] || []
                            let worksarr = _.cloneDeep(works)
                            if (me.scheduleWorkerFilter == `1`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_hospital_ward_id || _.includes(i.hospital_wardids, me.surgeryInfo.dic_hospital_ward_id)
                                })
                            } else if (me.scheduleWorkerFilter == `2`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_operating_ward_id || _.includes(i.wardids, me.surgeryInfo.dic_operating_ward_id)
                                })
                            }
                            if (this.$root.UseSurgeryScaleCheck == `1`) {
                                worksarr = worksarr.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        //  code: d.code,
                                        // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                        code: d.surgery_scale == null ? `--/${d.code}` : d.surgery_scale + `/` + d.code
                                    }
                                })
                            }
                            if (q && q.keyword) {
                                return worksarr.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return worksarr
                            }
                        }
                    },
                    config: {
                        collapseTags: false,
                        multipleLimit: 2
                    },
                    colspan: 6
                },
                {
                    type: `date`,
                    prop: `birthday`,
                    label: `出生日期`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    validate: [{ validator: validateTime, trigger: `blur` }],
                    change: (that, { row }) => {
                        let bir = row.birthday
                        let currentDate = this.$moment()
                        let birthDate = this.$moment(bir || ``)
                        let age = this.$moment.duration(currentDate.diff(birthDate))._data
                        row.age = age.years == 0 ? (age.months == 0 ? `${age.days}天` : `${age.months}月`) : `${age.years}岁`
                    }
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `dic_operating_ward_id`,
                    label: `手术区`,
                    isCreatable: true,
                    isEditable: true,
                    options: this[`operation_ward_auth`],
                    colspan: 6,
                    default: this.dic_operating_ward_id,
                    // validate: [{ required: true, message: `必填项目`, trigger: `change` }],
                    change: (that, { row }) => {
                        that.$parent.$parent.$parent.change_operating_ward_id = row.dic_operating_ward_id
                        row.dic_operating_room_id = undefined
                    }
                },
                {
                    type: `select`,
                    prop: `dic_operating_room_id`,
                    label: `手术间`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    readonly: (that, { row }) => {
                        return this.surgeryInfo && this.surgeryInfo.enum_surgery_status > 20
                    },
                    options: (that, { row }) => {
                        let r = _.filter(this[`operation_ward_auth`], { value: row.dic_operating_ward_id })
                        return (r && r[0] && r[0].operation_room) || []
                    },
                    change: (that, { row }) => {
                        that.$parent.$parent.$parent.change_operating_room_id = row.dic_operating_room_id
                    }
                    // validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `enum_visit_type`,
                    label: `就诊类型`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6,
                    default: 1,
                    options: this.sys_enums.VisitType || []
                    // validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `datetime`,
                    prop: `visit_time`,
                    label: `入院时间`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `multiselect`,
                    prop: `plan_anaes_methods`,
                    label: `麻醉方式`,
                    showCount: 3,
                    collapseTags: false,
                    isCreatable: true,
                    isEditable: true,
                    options: this[`surgery/anaesthesia_method`],
                    config: {
                        collapseTags: false
                    },
                    colspan: 12
                },
                {
                    type: `select`,
                    prop: `enum_pay_type`,
                    label: `费用类别`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_PayType || [],
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `insurance_no`,
                    label: `社保卡号`,
                    isCreatable: true,
                    isEditable: true,
                    validate: [
                        {
                            validator: validateSocietyCard,
                            trigger: `blur`
                        }
                    ],
                    colspan: 6
                },
                {
                    // type: `select`,
                    type: `remoteselect`,
                    prop: `plan_anes_doctor`,
                    label: this.T(`apply_surgery.plan_anes_doctor`),
                    isCreatable: true,
                    isEditable: true,
                    readonly: detaileditWorker,
                    // options: this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || [],
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let worksarr = _.cloneDeep(works)
                            if (me.scheduleWorkerFilter == `1`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_hospital_ward_id || _.includes(i.hospital_wardids, me.surgeryInfo.dic_hospital_ward_id)
                                })
                            } else if (me.scheduleWorkerFilter == `2`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_operating_ward_id || _.includes(i.wardids, me.surgeryInfo.dic_operating_ward_id)
                                })
                            }
                            if (this.$root.UseASACheck == `1`) {
                                worksarr = worksarr.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        //  code: d.code,
                                        // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code

                                    }
                                })
                            }
                            if (q && q.keyword) {
                                return worksarr.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return worksarr
                            }
                        }
                    },
                    colspan: 6
                },
                {
                    // type: `multiselect`,
                    type: `remotemultiselect`,
                    prop: `plan_anes_assistants`,
                    label: this.T(`apply_surgery.plan_anes_assistants`),
                    isCreatable: true,
                    isEditable: true,
                    readonly: detaileditWorker,
                    collapseTags: false,
                    options: (that, { row }) => { // added by xiaorui,ACIS-23399  排程界面的麻醉助手权限改动：既可以选择医生，又可选择护士
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`医生`] || [] : this.worker[`麻醉医生`] || []
                            let deepworkers = JSON.parse(JSON.stringify(works))
                            let hsworkers = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            hsworkers.forEach((item, index) => {
                                let mc = _.find(deepworkers, x => x.value == item.value)
                                if (mc) {
                                } else {
                                    deepworkers.push(item)
                                }
                            })
                            if (this.$root.UseASACheck == `1`) {
                                console.log(`过滤等级`)
                                deepworkers = deepworkers.map(d => {
                                    return {
                                        label: d.label,
                                        value: d.value,
                                        jianpin: d.jianpin,
                                        card_no: d.card_no,
                                        worker_duty: d.worker_duty,
                                        //  code: d.code,
                                        // worker_duty:d.worker_duty=="麻醉助手"?"麻醉医生":(d.worker_duty=="手术助手"?"手术医生":(d.worker_duty=="器械护士"?"巡回护士":d.worker_duty)),
                                        code: d.asa == null ? `--/${d.code}` : d.asa + `/` + d.code

                                    }
                                })
                            }
                            let worksarr = _.cloneDeep(deepworkers)
                            if (me.scheduleWorkerFilter == `1`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_hospital_ward_id || _.includes(i.hospital_wardids, me.surgeryInfo.dic_hospital_ward_id)
                                })
                            } else if (me.scheduleWorkerFilter == `2`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_operating_ward_id || _.includes(i.wardids, me.surgeryInfo.dic_operating_ward_id)
                                })
                            }

                            if (q && q.keyword) {
                                return worksarr.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return worksarr
                            }
                        }
                    },
                    config: {
                        collapseTags: false
                        // multipleLimit: 2
                    },
                    colspan: 6
                },
                {
                    type: `remoteselect`,
                    prop: `sectionobj`,
                    label: `科室`,
                    isCreatable: true,
                    isEditable: true,
                    options: (that, { row }) => {
                        return q => {
                            let sections = _.cloneDeep(this[`section_auth`])
                            console.log(`sections`, sections)
                            if (q && q.keyword) {
                                let f = sections.filter(d => {
                                    return d.code.indexOf(q.keyword) > -1 || d.label.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                                console.log(`f`, f)
                                return f
                            } else {
                                console.log(`search`, sections)
                                return sections
                            }
                        }
                    },
                    colspan: 6
                    // validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `remoteselect`,
                    prop: `inpatientobj`,
                    label: `病区`,
                    isCreatable: true,
                    isEditable: true,
                    // options:this["section_auth"],
                    options: (that, { row }) => {
                        return q => {
                            let sections = _.cloneDeep(this[`inpatient_section_auth`])
                            console.log(`sections`, sections)
                            if (q && q.keyword) {
                                let f = sections.filter(d => {
                                    return d.code.indexOf(q.keyword) > -1 || d.label.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                                console.log(`f`, f)
                                return f
                            } else {
                                console.log(`search`, sections)
                                return sections
                            }
                        }
                    },
                    colspan: 6,
                    default: this.dic_section_surgery
                },
                {
                    // type: `multiselect`,
                    type: `remotemultiselect`,
                    prop: `plan_circuit_nurse`,
                    label: this.T(`apply_surgery.plan_circuit_nurse`),
                    isCreatable: true,
                    isEditable: true,
                    collapseTags: false,
                    readonly: detaileditWorker,
                    // options: this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || [],
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let worksarr = _.cloneDeep(works)
                            if (me.scheduleWorkerFilter == `1`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_hospital_ward_id || _.includes(i.hospital_wardids, me.surgeryInfo.dic_hospital_ward_id)
                                })
                            } else if (me.scheduleWorkerFilter == `2`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_operating_ward_id || _.includes(i.wardids, me.surgeryInfo.dic_operating_ward_id)
                                })
                            }
                            if (q && q.keyword) {
                                return worksarr.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return worksarr
                            }
                        }
                    },
                    config: {
                        collapseTags: false
                        // multipleLimit: 2
                    },
                    colspan: 6
                },
                {
                    // type: `multiselect`,
                    type: `remotemultiselect`,
                    prop: `plan_equipment_nurse`,
                    label: this.T(`apply_surgery.plan_equipment_nurse`),
                    isCreatable: true,
                    isEditable: true,
                    collapseTags: false,
                    readonly: detaileditWorker,
                    // options: this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || [],
                    options: (that, { row }) => {
                        return q => {
                            let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                            let worksarr = _.cloneDeep(works)
                            if (me.scheduleWorkerFilter == `1`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_hospital_ward_id || _.includes(i.hospital_wardids, me.surgeryInfo.dic_hospital_ward_id)
                                })
                            } else if (me.scheduleWorkerFilter == `2`) {
                                worksarr = _.filter(worksarr, function(i) {
                                    return !me.surgeryInfo.dic_operating_ward_id || _.includes(i.wardids, me.surgeryInfo.dic_operating_ward_id)
                                })
                            }
                            if (q && q.keyword) {
                                return worksarr.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return worksarr
                            }
                        }
                    },
                    config: {
                        collapseTags: false
                        // multipleLimit: 2
                    },
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `is_fasting`,
                    label: `术前禁食`,
                    isCreatable: true,
                    isEditable: true,
                    options: `enum_bool`,
                    colspan: 6
                },

                {
                    type: `string`,
                    prop: `address`,
                    label: `地址`,
                    isCreatable: true,
                    isEditable: true,
                    validate: [{ min: 0, max: 50, message: `长度50个字符以内`, trigger: `blur` }],
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_asa`,
                    label: `ASA`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.Enum_ASA || [],
                    colspan: 6
                },
                {
                    type: `multiselect`,
                    prop: `infectious`,
                    label: this.T(`apply_surgery.infectious`),
                    isCreatable: true,
                    isEditable: true,
                    // options: `enum_infectious`,
                    options: (that, { row }) => {
                        let data = this.sys_enums.Enum_Infectious || []
                        var ret = data.map(d => {
                            d.value = d.label
                            return d
                        })
                        return ret
                    },
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `enum_isolation_status`,
                    label: `隔离状态`,
                    isCreatable: true,
                    isEditable: true,
                    options: this.sys_enums.IsolationStatus || [],
                    colspan: 6
                },
                {
                    type: `string`,
                    prop: `his_remark`,
                    label: `申请备注`,
                    isCreatable: true,
                    isEditable: true,
                    readonly: true,
                    colspan: 12
                },
                {
                    type: `string`,
                    prop: `remark`,
                    label: `备注`,
                    isCreatable: true,
                    isEditable: true,
                    validate: [{ min: 0, max: 60, message: `长度60个字符以内`, trigger: `blur` }],
                    colspan: 24
                }
            ]
            // 批处理是否可编辑那些属性
            createC = this.$surgeryInfoExtraParamUtil.SetOtherSettingColumn(createC, this.otherSettingColumn)
            // 显示动态扩展列
            createC = this.$surgeryInfoExtraParamUtil.SetExtraColumnList(this.extendColumnList, createC)
            createC = _.filter(createC, function(d) {
                return d.isEditable === true
            })
            return createC
        },
        visibleSync: {
            get: function() {
                if (this.visible) {
                    this.loadOne()
                }
                return this.visible
            },
            set: function(newval) {
                this.$emit(`update:visible`, newval)
            }
        },
        IsHavePermission() {
            return permissionNo => {
                return _.find(this.permissions, { no: permissionNo }) != undefined
            }
        },
        canEdit() {
            // 手术麻醉单归档后不能在保存
            let caneditarchived = this.IsHavePermission(`dic_surgery_caneditarchived`)
            if (caneditarchived) {
                return true
            } else {
                return !this.surgeryInfo.is_archived
            }
        },
        enabledEditButtons() {
            let bts = (this.editButtons || []).map(b => Object.assign(new definition.TouchButtonDefinition({}), b))
            return bts
        }
    },
    methods: {
        validateData(data) {
            let societyCardReg = ``
            if (data.card_no) {
                switch (data.card_type) {
                case 1:
                    societyCardReg = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/ // 身份证
                    break
                case 2:
                    societyCardReg = /^[A-Za-z0-9]{5,20}$/ // 护照
                    break
                }
                if (!societyCardReg.test(data.card_no)) {
                    this.$message.error(`证件号格式错误`)
                    throw new Error(`EndIterative`)
                }
            }
        },
        loadOne() {
            if (!this.surgeryId) return
            let req = this.myaxios.get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
            req.then(data => {
                let obj = {
                    id: data.id,
                    is_archived: data.is_archived, // 手术对应的麻醉单是否已归档
                    sequence: data.sequence,
                    plan_time: data.plan_time,
                    cost_time: data.cost_time,
                    infectious: data.infectious && data.infectious.split(`,`),
                    is_fasting: data.is_fasting,
                    is_day_surgery: data.is_day_surgery,
                    is_endoscopy: data.is_endoscopy,
                    his_remark: data.his_remark,
                    remark: data.remark,
                    enum_asa: data.enum_asa,
                    enum_surgery_scale: data.enum_surgery_scale,
                    enum_surgery_type: data.enum_surgery_type,
                    dic_section_id: data.dic_section_id,
                    sectionobj: data.sectionobj,
                    dic_inpatient_section_id: data.dic_inpatient_section_id,
                    inpatientobj: data.inpatientobj,
                    dic_operating_room_id: data.dic_operating_room_id,
                    dic_operating_ward_id: data.dic_operating_ward_id,
                    dic_hospital_ward_id: data.hospital_ward && data.hospital_ward.id,
                    enum_isolation_status: data.enum_isolation_status,
                    enum_cut_level: data.enum_cut_level,
                    enum_outoperatingroomtype: data.enum_outoperatingroomtype,
                    age: data.visit_info.age,
                    nation: data.visit_info.nation,
                    height: data.visit_info.height,
                    weight: data.visit_info.weight,
                    bed_no: data.visit_info.bed_no,
                    visit_no: data.visit_info.visit_no,
                    outpatient_no: data.visit_info.outpatient_no,
                    visit_time: data.visit_info.visit_time,
                    phone: data.visit_info.phone,
                    address: data.visit_info.address,
                    enum_visit_type: data.visit_info.enum_visit_type,
                    enum_pay_type: data.visit_info.enum_pay_type,
                    name: data.visit_info.name,
                    birthday: data.visit_info.birthday,
                    card_type: data.visit_info.card_type,
                    card_no: data.visit_info.card_no,
                    his_id: data.visit_info.his_id,
                    insurance_no: data.visit_info.insurance_no,
                    enum_blood_type: data.visit_info.enum_blood_type,
                    enum_rh_blood_type: data.visit_info.enum_rh_blood_type,
                    enum_sex: data.visit_info.enum_sex,
                    plan_diseases: data.plan_diseases,
                    plan_surgeries: data.plan_surgeries,
                    plan_surgeon: data.plan_surgeon,
                    // plan_surgeon_assistants: data.plan_surgeon_assistants && data.plan_surgeon_assistants.map(d => d.value),
                    plan_surgeon_assistants: data.plan_surgeon_assistants,
                    // plan_anes_doctor: data.plan_anes_doctor && data.plan_anes_doctor.value,
                    plan_anes_doctor: data.plan_anes_doctor,
                    // plan_anes_assistants: data.plan_anes_assistants && data.plan_anes_assistants.map(d => d.value),
                    plan_anes_assistants: data.plan_anes_assistants,
                    // plan_circuit_nurse: data.plan_circuit_nurse && data.plan_circuit_nurse.map(d => d.value),
                    plan_circuit_nurse: data.plan_circuit_nurse,
                    // plan_equipment_nurse: data.plan_equipment_nurse && data.plan_equipment_nurse.map(d => d.value),
                    plan_equipment_nurse: data.plan_equipment_nurse,
                    plan_anaes_methods: data.plan_anaes_methods && data.plan_anaes_methods.map(d => d.value),
                    enum_surgery_status: data.enum_surgery_status,
                    surgery_items: data.surgery_items // 拟施手术 Table展现形式
                }

                // getone的时候把动态列字段放到obj对象里面
                this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, obj, data)
                this.surgeryInfo = obj
                this.oldoperating_room_id = this.change_operating_room_id = data.dic_operating_room_id
                this.oldoperating_ward_id = this.change_operating_ward_id = data.dic_operating_ward_id // 新计划手术时间
                this.oldplan_time = this.change_plan_time = data.plan_time // 初始计划手术时间
            }).catch(e => {
                console.log(e)
            })
        },
        putOne(data) {
            let that = this
            // that.validateData(data)
            if ((data.isExtraBtnClick || data.enum_surgery_status == 20) && !data.dic_operating_room_id) {
                this.$message.error(`请选择手术间！`)
                throw new Error(`EndIterative`)
            }
            var obj = {
                id: data.id,
                sequence: data.sequence,
                plan_time: data.plan_time,
                cost_time: data.cost_time,
                infectious: data.infectious && data.infectious.join(`,`),
                is_fasting: data.is_fasting,
                is_day_surgery: data.is_day_surgery,
                is_endoscopy: data.is_endoscopy,
                remark: data.remark,
                enum_asa: data.enum_asa || `-1`,
                enum_surgery_scale: data.enum_surgery_scale || `-1`,
                enum_outoperatingroomtype: data.enum_outoperatingroomtype,
                enum_surgery_type: data.enum_surgery_type || `-1`,
                dic_section_id: data.sectionobj && data.sectionobj.value || `-1`,
                dic_inpatient_section_id: data.inpatientobj && data.inpatientobj.value || `-1`,
                dic_operating_room_id: data.dic_operating_room_id || `-1`,
                dic_operating_ward_id: data.dic_operating_ward_id || `-1`,
                enum_isolation_status: data.enum_isolation_status || `-1`,
                enum_cut_level: data.enum_cut_level || `-1`,
                visit_info: {
                    age: data.age,
                    nation: data.nation,
                    height: data.height,
                    weight: data.weight,
                    bed_no: data.bed_no,
                    visit_no: data.visit_no,
                    outpatient_no: data.outpatient_no,
                    visit_time: data.visit_time,
                    phone: data.phone,
                    address: data.address,
                    enum_visit_type: data.enum_visit_type || `-1`,
                    enum_pay_type: data.enum_pay_type || `-1`,
                    name: data.name,
                    birthday: data.birthday,
                    card_type: data.card_type,
                    card_no: data.card_no,
                    insurance_no: data.insurance_no,
                    enum_blood_type: data.enum_blood_type || `-1`,
                    enum_rh_blood_type: data.enum_rh_blood_type || `-1`,
                    enum_sex: data.enum_sex === `` ? `-1` : data.enum_sex,
                    his_id: data.his_id
                },
                plan_anaes_methods: data.plan_anaes_methods,
                plan_diseases: data.plan_diseases.map(d => d.value),
                plan_surgeries: data.plan_surgeries.map(d => d.value),
                plan_surgeon: data.plan_surgeon && data.plan_surgeon.value,
                plan_surgeon_assistants: data.plan_surgeon_assistants && data.plan_surgeon_assistants.map(d => d.value),
                plan_anes_doctor: data.plan_anes_doctor && data.plan_anes_doctor.value || `-1`,
                plan_anes_assistants: data.plan_anes_assistants && data.plan_anes_assistants.map(d => d.value),
                plan_circuit_nurse: data.plan_circuit_nurse && data.plan_circuit_nurse.map(d => d.value),
                plan_equipment_nurse: data.plan_equipment_nurse && data.plan_equipment_nurse.map(d => d.value)
            }
            var r = _.map(data.surgery_items, d => {
                d.plan_surgeries = d.plan_surgeries && d.plan_surgeries.value
                return d
            })
            obj.surgery_items = r
            // 修改的时候把动态列字段放到obj.extra_datas对象里面
            this.$surgeryInfoExtraParamUtil.SetSurgeryInfoExtraDatas(this.extendColumnList, obj, data)
            if (data.enum_surgery_status < 0 || data.enum_surgery_status > 20) {
                that.$message.warning(`不允许操作手术中、手术结束、苏醒中、苏醒结束的手术`)
                return
            }
            // 点击了确认排程
            if (data.isExtraBtnClick) {
                // 跨区域排程需要给提示
                if (that.change_operating_ward_id != that.oldoperating_ward_id) {
                    return that.$confirm(`请确认${obj.visit_info.name}是否跨区排程?`, `提示`, {
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`,
                        closeOnClickModal: false
                    }).then(() => {
                        // 走修改逻辑
                        that.PutScheduleSurgery(data, obj, `after-save`)
                    }).catch(e => {

                    })
                } else {
                // 走修改逻辑
                    that.PutScheduleSurgery(data, obj, `after-save`)
                }
            } else {
                // 点击了已排程且 改了手术区和手术间的
                if (data.enum_surgery_status == 20 && (that.change_operating_room_id != that.oldoperating_room_id ||
                    that.change_operating_ward_id != that.oldoperating_ward_id)) {
                    // 跨区域排程需要给提示
                    if (that.change_operating_ward_id != that.oldoperating_ward_id) {
                        return that.$confirm(`请确认${obj.visit_info.name}是否跨区排程?`, `提示`, {
                            confirmButtonText: `确定`,
                            cancelButtonText: `取消`,
                            type: `warning`,
                            closeOnClickModal: false
                        }).then(() => {
                            that.ReScheduleSurgery(data, obj)
                        }).catch(e => {

                        })
                    } else {
                        that.ReScheduleSurgery(data, obj)
                    }
                } else {
                    // 走修改逻辑
                    that.PutScheduleSurgery(data, obj, `save`)
                }
            }
        },
        ReScheduleSurgery(data, obj) {
            let that = this
            // 走重新排程逻辑
            let planTime = that.$moment(obj.plan_time).format(`YYYY/MM/DD HH:mm:00`)
            let req = that.myaxios.put(
                `/api/Preoperative/Schedule/ReScheduleSurgery?operatingRoomId=${obj.dic_operating_room_id}&operatingWardId=${obj.dic_operating_ward_id}&surgeryId=${obj.id}&date=${planTime}`
            )
            req.then(req => {
                // 走修改逻辑
                let req1 = that.myaxios.put(`/api/Preoperative/Apply/Put`, obj)
                req1.then(req => {
                    that.visibleSync = false
                    that.$emit(`save`, data.id, data.enum_surgery_status, data.dic_operating_room_id, data.plan_time)
                }).catch(e => console.log(e))
            }).catch(e => console.log(e))
        },
        PutScheduleSurgery(data, obj, flag) {
            let that = this
            // 走修改逻辑
            let req = that.myaxios.put(`/api/Preoperative/Apply/Put`, obj)
            req.then(req => {
                this.visibleSync = false
                // 点击了确认排程
                this.$emit(flag, data.id, data.enum_surgery_status, data.dic_operating_room_id, data.plan_time)
            }).catch(e => console.log(e))
        }
    }
}
</script>
<style scoped>
</style>
<style lang="less">
.plan_diseases{
    .el-select__tags-text{
        white-space:normal;
    }
    .el-tag--mini{
        height: unset !important;
    }
}
.plan_surgeries{
    .el-select__tags-text{
        white-space:normal;
    }
    .el-tag--mini{
        height: unset !important;
    }
}
.title1 p {
    background: lightgray;
    font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Scheduling/EditSurgery.vue